import React, { useState, useEffect } from 'react';
import {object, func} from 'prop-types';
import { ALERT_TYPE, OPERATION_MODE, REQUEST_METHOD, ShowToastMessage, TRIBUTO_TYPE } from '@laramie/ui';
import {
    DatePickerCustom,
    InputNumber,
    InputPersona,
    InputTasa,
    InputSubTasa,
    Loading,
    InputCuenta,
    InputLista,
    InputCodigo,
    TableCustom,
    InputEntidad,
    Accordion,
    Modal
} from '../../common';
import InputEjercicio from '../../common/InputEjercicio';
import {useUsuario} from '../../hooks/useUsuario';
import {APIS} from '../../../config/apis';
import {APPCONFIG} from '../../../app.config';
import {ServerRequest} from '../../../utils/apiweb';
import {useEntidad} from '../../hooks/useEntidad';
import {usePermissions} from '../../hooks/usePermissions';
import {PERMISSIONS} from '../../../consts/permissions';
import {getDateToString, getFormatNumber} from '../../../utils/convert';
import InputUsuario from '../../common/InputUsuario';


const CuentaCorrienteItemModal = (props) => {

    //variables
    const entityInit = {
        cuentaCorrienteItem: {
            id: 0,
            idCuentaCorriente: 0,
            idEmisionEjecucion: 0,
            idEmisionCuentaCorrienteResultado: 0,
            idPlanPago: 0,
            idPlanPagoCuota: 0,
            idCertificadoApremio: 0,
            idCuenta: 0,
            idTasa: 0,
            idSubTasa: 0,
            periodo: '',
            cuota: 0,
            codigoDelegacion: '',
            idTipoMovimiento: 0,
            numeroMovimiento: 0,
            idTipoValor: 0,
            importeDebe: 0,
            importeHaber: 0,
            idLugarPago: 0,
            fechaOrigen: null,
            fechaMovimiento: null,
            fechaVencimiento1: null,
            fechaVencimiento2: null,
            fechaVencimiento1Original: null,
            fechaVencimiento2Original: null,
            fechaVencimiento1Prorroga: null,
            fechaVencimiento2Prorroga: null,
            cantidad: 0,
            idEdesurCliente: 0,
            detalle: '',
            item: 0,
            idUsuarioRegistro: 0,
            fechaRegistro: null,
            idUsuarioProceso: 0,
            fechaProceso: null,
            fechaCobro: null,
            numeroPartidaOrigen: 0
        },
        emisionEjecucion: {
            id: 0,
            idEmisionDefinicion: 0,
            idEstadoEmisionEjecucion: 0,
            idEmisionEjecucionAdelantada: 0,
            numero: '',
            descripcion: '',
            periodo: '',
            imprimeRecibosEmision: false,
            procesaPlanes: false,
            aplicaDebitoAutomatico: false,
            calculoMostradorWeb: false,
            calculoMasivo: false,
            calculoPrueba: false,
            calculoPagoAnticipado: false,
            fechaReliquidacionDesde: null,
            fechaReliquidacionHasta: null,
            fechaPagoAnticipadoVencimiento1: null,
            fechaPagoAnticipadoVencimiento2: null,
            fechaEjecucionInicio: null,
            fechaEjecucionFin: null
        },
        certificadoApremio: {
            id: 0,
            idApremio: 0,
            idEstadoCertificadoApremio: 0,
            numero: '',
            idCuenta: 0,
            idInspeccion: 0,
            montoTotal: 0,
            fechaCertificado: null,
            fechaCalculo: null,
            fechaNotificacion: null,
            fechaRecepcion: null,
            idFirmaDigitalTituloEjecutivo: null,
            idEstadoFirmaTituloEjecutivo: null,
            pagoHabilitado: false
        },
        cuenta: {
            id: 0,
            numeroCuenta: '',
            numeroWeb: '',
            idEstadoCuenta: 0,
            idTipoTributo: 0,
            idTributo: 0,
            fechaAlta: null,
            fechaBaja: null,
            idContribuyentePrincipal: 0,
            idDireccionPrincipal: 0,
            idDireccionEntrega: 0
        },
        tasa: {
            id: 0,
            codigo: '',
            idTipoTributo: 0,
            idCategoriaTasa: 0,
            descripcion: '',
            porcentajeDescuento: 0
        },
        subTasa: {
            id: 0,
            idTasa: 0,
            codigo: '',
            descripcion: '',
            impuestoNacional: 0,
            impuestoProvincial: 0,
            ctasCtes: 0,
            timbradosExtras: 0,
            descripcionReducida: '',
            fechaDesde: null,
            fechaHasta: null,
            rubroGenerico: false,
            liquidableCtaCte: false,
            liquidableDDJJ: false,
            actualizacion: false,
            accesorios: false,
            internetDDJJ: false,
            imputXPorc: false
        },
        edesurCliente: {
            id: 0,
            idEdesur: 0,
            idPersona: 0,
            idTipoPersona: 0,
            nombrePersona: '',
            idTipoDocumento: 0,
            numeroDocumento: '',
            codigoCliente: '',
            fechaDesde: null,
            fechaHasta: null
        },
        cuotaPorcentajes: [],
        asignacionOrigenes: [],
        asignacionDestinos: [],
        retencion: {
            idRetencion: 0,
            numeroPartidaAgente: 0,
            idCuentaAgente: 0,
            numeroCuentaAgente: '',
            nombreAgente: '',
            cuitAgente: '',
            fechaPresentacion: null,
            anioDeclaracion: '',
            mesDeclaracion: 0,
            numeroComprobante: ''
        }
    };

    //hooks
    const [state, setState] = useState({
        loading: false,
        entity: entityInit,
    });
    const [idTipoTributo, setIdTipoTributo] = useState(0);

    const mount = () => {
        if (props.data.idCuentaCorrienteItem > 0) {
            setIdTipoTributo(props.data.idTipoTributo);
            FindCuentaCorrienteItem(props.data.idCuentaCorrienteItem);
        }
    }
    useEffect(mount, [props.data.idCuentaCorrienteItem]);

    const [getDataUsuario] = useUsuario({
        idUsuario: state.entity.cuentaCorrienteItem.idUsuarioRegistro,
        onLoaded: (idUsuario, isSuccess, error) => {
            if (!isSuccess) {
                ShowToastMessage(ALERT_TYPE.ALERT_ERROR, error);
            }
        }
    });

    const [, getRowEntidad] = useEntidad({
        entidades: ['Tasa', 'SubTasa', 'TipoMovimiento'],
        onLoaded: (entidades, isSuccess, error) => {
            if (isSuccess) {
                setState(prevState => ({...prevState}));
            } else {
                ShowToastMessage(ALERT_TYPE.ALERT_ERROR, error);
            }
        },
        memo: {
            key: 'Tasa_SubTasa_TipoMovimiento',
            timeout: 0
        }
    });

    const { hasPermission } = usePermissions();
    const canViewCuentaCorriente = hasPermission(PERMISSIONS.CUENTA_CORRIENTE_VIEW);


    //callbacks
    const callbackNoSuccess = (response) => {
        response.json()
            .then((error) => {
                const message = error.message;
                ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
                setState(prevState => {
                    return {...prevState, loading: false};
                });
            })
            .catch((error) => {
                const message = 'Error procesando respuesta: ' + error;
                ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
                setState(prevState => {
                    return {...prevState, loading: false};
                });
            });
    }
    const callbackError = (error) => {
        const message = 'Error procesando solicitud: ' + error.message;
        ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
        setState(prevState => {
            return {...prevState, loading: false};
        });
    }
    const callbackSuccessFindCuenta = (response) => {
        response.json()
            .then((data) => {

                if (data.cuentaCorrienteItem.fechaOrigen) data.cuentaCorrienteItem.fechaOrigen = new Date(data.cuentaCorrienteItem.fechaOrigen);
                if (data.cuentaCorrienteItem.fechaMovimiento) data.cuentaCorrienteItem.fechaMovimiento = new Date(data.cuentaCorrienteItem.fechaMovimiento);
                if (data.cuentaCorrienteItem.fechaVencimiento1) data.cuentaCorrienteItem.fechaVencimiento1 = new Date(data.cuentaCorrienteItem.fechaVencimiento1);
                if (data.cuentaCorrienteItem.fechaVencimiento2) data.cuentaCorrienteItem.fechaVencimiento2 = new Date(data.cuentaCorrienteItem.fechaVencimiento2);
                if (data.cuentaCorrienteItem.fechaVencimiento1Original) data.cuentaCorrienteItem.fechaVencimiento1Original = new Date(data.cuentaCorrienteItem.fechaVencimiento1Original);
                if (data.cuentaCorrienteItem.fechaVencimiento2Original) data.cuentaCorrienteItem.fechaVencimiento2Original = new Date(data.cuentaCorrienteItem.fechaVencimiento2Original);
                if (data.cuentaCorrienteItem.fechaVencimiento1Prorroga) data.cuentaCorrienteItem.fechaVencimiento1Prorroga = new Date(data.cuentaCorrienteItem.fechaVencimiento1Prorroga);
                if (data.cuentaCorrienteItem.fechaVencimiento2Prorroga) data.cuentaCorrienteItem.fechaVencimiento2Prorroga = new Date(data.cuentaCorrienteItem.fechaVencimiento2Prorroga);
                if (data.cuentaCorrienteItem.fechaVencimiento1Original) data.cuentaCorrienteItem.fechaVencimiento1Original = new Date(data.cuentaCorrienteItem.fechaVencimiento1Original);
                if (data.cuentaCorrienteItem.fechaVencimiento2Original) data.cuentaCorrienteItem.fechaVencimiento2Original = new Date(data.cuentaCorrienteItem.fechaVencimiento2Original);
                if (data.cuentaCorrienteItem.fechaVencimiento1Prorroga) data.cuentaCorrienteItem.fechaVencimiento1Prorroga = new Date(data.cuentaCorrienteItem.fechaVencimiento1Prorroga);
                if (data.cuentaCorrienteItem.fechaVencimiento2Prorroga) data.cuentaCorrienteItem.fechaVencimiento2Prorroga = new Date(data.cuentaCorrienteItem.fechaVencimiento2Prorroga);
                if (data.cuentaCorrienteItem.fechaRegistro) data.cuentaCorrienteItem.fechaRegistro = new Date(data.cuentaCorrienteItem.fechaRegistro);
                if (data.cuentaCorrienteItem.fechaProceso) data.cuentaCorrienteItem.fechaProceso = new Date(data.cuentaCorrienteItem.fechaProceso);
                if (data.cuentaCorrienteItem.fechaCobro) data.cuentaCorrienteItem.fechaCobro = new Date(data.cuentaCorrienteItem.fechaCobro);
                if (data.emisionEjecucion.fechaEjecucionInicio) data.emisionEjecucion.fechaEjecucionInicio = new Date(data.emisionEjecucion.fechaEjecucionInicio);
                if (data.emisionEjecucion.fechaEjecucionFin) data.emisionEjecucion.fechaEjecucionFin = new Date(data.emisionEjecucion.fechaEjecucionFin);
                if (data.certificadoApremio.fechaCertificado) data.certificadoApremio.fechaCertificado = new Date(data.certificadoApremio.fechaCertificado);
                data.asignacionOrigenes = data.asignacionOrigenes ?? [];
                data.asignacionDestinos = data.asignacionDestinos ?? [];
                [...data.asignacionOrigenes, ...data.asignacionDestinos].forEach(asignacion => { if (asignacion.fechaMovimiento) asignacion.fechaMovimiento = new Date(asignacion.fechaMovimiento); });
                data.retencion = data.retencion ?? entityInit.retencion;
                if (data.retencion.fechaPresentacion) data.retencion.fechaPresentacion = new Date(data.retencion.fechaPresentacion);

                setState(prevState => {
                    return {...prevState, loading: false, entity: data};
                });
            })
            .catch((error) => {
                const message = 'Error procesando respuesta: ' + error;
                ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
                setState(prevState => {
                    return {...prevState, loading: false};
                });
            });
    }

    //funciones
    function FindCuentaCorrienteItem(idCuentaCuentaCorrienteItem) {

        setState(prevState => {
            return {...prevState, loading: true};
        });

        const paramsUrl = `/${idCuentaCuentaCorrienteItem}`;

        ServerRequest(
            REQUEST_METHOD.GET,
            null,
            true,
            APIS.URLS.CUENTA_CORRIENTE_ITEM,
            paramsUrl,
            null,
            callbackSuccessFindCuenta,
            callbackNoSuccess,
            callbackError
        );

    }

    const getCodigoTasa = (id) => {
        const row = getRowEntidad('Tasa', id);
        return (row) ? row.codigo : '';
    }
    const getCodigoSubTasa = (id) => {
        const row = getRowEntidad('SubTasa', id);
        return (row) ? row.codigo : '';
    }
    const getDescTasa = (id) => {
        const row = getRowEntidad('Tasa', id);
        return (row) ? `${row.codigo} - ${row.descripcion}` : '';
    }
    const getDescSubTasa = (id) => {
        const row = getRowEntidad('SubTasa', id);
        return (row) ? `${row.codigo} - ${row.descripcion}` : '';
    }
    const getDescTipoMovimiento = (id) => {
        const row = getRowEntidad('TipoMovimiento', id);
        return (row) ? row.nombre : '';
    }
    const handleClickPartidaView = (idCuenta, numeroPartida) => {
        const url = APPCONFIG.SITE.WEBAPP + 'cuenta-corriente/cuenta/' + OPERATION_MODE.VIEW + '/' + idCuenta + '?numeroPartida=' + numeroPartida;
        window.open(url, '_blank');
    }

    const cellPartidaView = ({row}) => canViewCuentaCorriente &&
                                <div className='action'>
                                    <div onClick={ (event) => handleClickPartidaView(row.original.idCuenta, row.original.numeroPartida) } className="link">
                                        <span className="material-symbols-outlined" title="Ver cuenta corriente de la partida">open_in_new</span>
                                    </div>
                                </div>

    const getAsignacionColumns = (columnaDescripcion) => [
        { Header: 'Partida', accessor: 'numeroPartida', width: '12%', alignCell: 'right', disableSortBy: true, ellipsis: false },
        columnaDescripcion,
        { Header: 'Período', Cell: ({row}) => `${row.original.periodo}/${row.original.cuota}`, accessor: 'periodo', width: '11%', alignCell: 'right', disableSortBy: true, ellipsis: false },
        { Header: 'Fecha', Cell: (props) => (props.value) ? getDateToString(props.value, false) : '', accessor: 'fechaMovimiento', width: '13%', disableSortBy: true, ellipsis: false },
        { Header: 'Importe aplicado', Cell: (props) => getFormatNumber(props.value, 2), accessor: 'importe', width: '21%', alignCell: 'right', disableSortBy: true, ellipsis: false },
        { Header: '', Cell: cellPartidaView, id: 'abm', accessor: 'numeroPartida', width: '6%', disableGlobalFilter: true, disableSortBy: true, ellipsis: false }
    ];
    const asignacionOrigenesColumns = getAsignacionColumns(
        { Header: 'Tipo de crédito', Cell: (props) => getDescTipoMovimiento(props.value), accessor: 'idTipoMovimiento', width: '37%', disableSortBy: true }
    );
    const asignacionDestinosColumns = getAsignacionColumns(
        { Header: 'Tasa', Cell: (props) => getDescTasa(props.value), accessor: 'idTasa', width: '37%', disableSortBy: true }
    );

    const hasAsignacionOrigenes = state.entity.asignacionOrigenes.length > 0;
    const hasAsignacionDestinos = state.entity.asignacionDestinos.length > 0;

    const hasRetencion = state.entity.retencion.idRetencion > 0;
    const retencionRecibida = hasRetencion && state.entity.retencion.idCuentaAgente !== state.entity.cuentaCorrienteItem.idCuenta;

    const tableColumns = [
        {
            Header: 'Tasa',
            Cell: (props) => getCodigoTasa(props.value),
            accessor: 'idTasa',
            width: '10%',
            alignCell: 'right',
            disableSortBy: true
        },
        {
            Header: 'Sub tasa',
            Cell: (props) => getCodigoSubTasa(props.value),
            accessor: 'idSubTasa',
            width: '10%',
            alignCell: 'right',
            disableSortBy: true
        },
        {
            Header: 'Tasa %',
            Cell: (props) => getDescTasa(props.value),
            accessor: 'idTasaPorcentaje',
            width: '35%',
            disableSortBy: true
        },
        {
            Header: 'Sub tasa %',
            Cell: (props) => getDescSubTasa(props.value),
            accessor: 'idSubTasaPorcentaje',
            width: '35%',
            disableSortBy: true
        },
        {
            Header: 'Porcentaje',
            Cell: (props) => getFormatNumber(props.value, 2),
            accessor: 'porcentaje',
            width: '10%',
            alignCell: 'right',
            disableSortBy: true
        }
    ];

    return (
        <>

            <Loading visible={state.loading}></Loading>

            <Modal
                size="lg"
                title={`Movimiento de cuenta corriente (ID: ${state.entity.cuentaCorrienteItem.numeroPartida}-${state.entity.cuentaCorrienteItem.id})`}
                onEscape={() => props.onDismiss()}
                body={(
                            <div className="row">

                                <div className="mb-3 col-12">
                                    <Accordion title="Datos" startOpen={true}>
                                        <div className='row form-basic'>
                                            <div className="mb-3 col-12 col-md-6">
                                                <label htmlFor="cuenta" className="form-label">Cuenta</label>
                                                <InputCuenta
                                                    name="cuenta"
                                                    placeholder=""
                                                    className="form-control"
                                                    value={state.entity.cuentaCorrienteItem.idCuenta}
                                                    disabled={true}
                                                />
                                            </div>
                                            <div className="mb-3 col-8 col-md-4">
                                                <label htmlFor="periodo" className="form-label">Período</label>
                                                <InputEjercicio
                                                    name="periodo"
                                                    placeholder=""
                                                    className="form-control"
                                                    value={state.entity.cuentaCorrienteItem.periodo}
                                                    disabled={true}
                                                />
                                            </div>
                                            <div className="mb-3 col-4 col-md-2">
                                                <label htmlFor="cuota" className="form-label">Cuota</label>
                                                <InputCodigo
                                                    name="cuota"
                                                    type="text"
                                                    className="form-control"
                                                    value={state.entity.cuentaCorrienteItem.cuota.toString()}
                                                    disabled={true}
                                                />
                                            </div>

                                            <div className="mb-3 col-12 col-md-6">
                                                <label htmlFor="idTasa" className="form-label">Tasa</label>
                                                <InputTasa
                                                    name="idTasa"
                                                    placeholder=""
                                                    className="form-control"
                                                    value={state.entity.cuentaCorrienteItem.idTasa}
                                                    disabled={true}
                                                />
                                            </div>
                                            <div className="mb-3 col-12 col-md-6">
                                                <label htmlFor="idSubTasa" className="form-label">Sub tasa</label>
                                                <InputSubTasa
                                                    name="idSubTasa"
                                                    placeholder=""
                                                    className="form-control"
                                                    value={state.entity.cuentaCorrienteItem.idSubTasa}
                                                    disabled={true}
                                                />
                                            </div>
                                            {(idTipoTributo === TRIBUTO_TYPE.COMERCIOS) &&
                                                <div className="mb-3 col-12">
                                                    <label htmlFor="idRubro" className="form-label">Rubro</label>
                                                    <InputEntidad
                                                        name="idRubro"
                                                        placeholder=""
                                                        className="form-control"
                                                        value={state.entity.cuentaCorrienteItem.idRubro}
                                                        entidad='Rubro'
                                                        disabled={true}
                                                        onFormat={row => (row) ? `${row.codigo} - ${row.nombre}` : ''}
                                                    />
                                                </div>
                                            }
                                            <div className="mb-3 col-12">
                                                <label htmlFor="item" className="form-label">Observación</label>
                                                <input
                                                    name="item"
                                                    type="text"
                                                    className="form-control"
                                                    value={state.entity.cuentaCorrienteItem.detalle}
                                                    disabled={true}
                                                />
                                            </div>

                                        </div>
                                    </Accordion>
                                </div>

                                <div className="mb-3 col-12">
                                    <Accordion title="Movimiento">
                                        <div className='row form-basic'>
                                            <div className="mb-3 col-12 col-md-4">
                                                <label htmlFor="fechaMovimiento"
                                                       className="form-label">Fecha</label>
                                                <DatePickerCustom
                                                    name="fechaMovimiento"
                                                    placeholder=""
                                                    className="form-control"
                                                    value={state.entity.cuentaCorrienteItem.fechaMovimiento}
                                                    disabled={true}
                                                />
                                            </div>
                                            <div className="mb-3 col-12 col-md-8">
                                                <label htmlFor="idTipoMovimiento" className="form-label">Tipo de
                                                    movimiento</label>
                                                <InputEntidad
                                                    name="idTipoMovimiento"
                                                    placeholder=""
                                                    className="form-control"
                                                    value={state.entity.cuentaCorrienteItem.idTipoMovimiento}
                                                    disabled={true}
                                                    entidad="TipoMovimiento"
                                                />
                                            </div>

                                            <div className="mb-3 col-4 col-md-4">
                                                <label htmlFor="codigoDelegacion"
                                                       className="form-label">Delegación</label>
                                                <InputCodigo
                                                    name="codigoDelegacion"
                                                    type="text"
                                                    className="form-control"
                                                    value={state.entity.cuentaCorrienteItem.codigoDelegacion}
                                                    disabled={true}
                                                />
                                            </div>
                                            <div className="mb-3 col-6 col-md-4">
                                                <label htmlFor="numeroMovimiento"
                                                       className="form-label">Número</label>
                                                <InputCodigo
                                                    name="numeroMovimiento"
                                                    type="text"
                                                    className="form-control"
                                                    value={state.entity.cuentaCorrienteItem.numeroMovimiento.toString()}
                                                    disabled={true}
                                                />
                                            </div>
                                            <div className="mb-3 col-2 col-md-4">
                                                <label htmlFor="item" className="form-label">Item</label>
                                                <input
                                                    name="item"
                                                    type="text"
                                                    className="form-control"
                                                    value={state.entity.cuentaCorrienteItem.item}
                                                    disabled={true}
                                                />
                                            </div>

                                            <div className="mb-3 col-8">
                                                <label htmlFor="idLugarPago" className="form-label">Lugar de
                                                    pago</label>
                                                <InputLista
                                                    name="idLugarPago"
                                                    placeholder=""
                                                    className="form-control"
                                                    value={state.entity.cuentaCorrienteItem.idLugarPago}
                                                    disabled={true}
                                                    lista="LugarPago"
                                                />
                                            </div>
                                            <div className="mb-3 col-4">
                                                <label htmlFor="fechaCobro" className="form-label">Fecha de
                                                    cobro</label>
                                                <DatePickerCustom
                                                    name="fechaCobro"
                                                    placeholder=""
                                                    className="form-control"
                                                    value={state.entity.cuentaCorrienteItem.fechaCobro}
                                                    disabled={true}
                                                />
                                            </div>

                                            <div className="mb-3 col-4">
                                                <label htmlFor="idTipoValor" className="form-label">Tipo de
                                                    valor</label>
                                                <InputLista
                                                    name="idTipoValor"
                                                    placeholder=""
                                                    className="form-control"
                                                    value={state.entity.cuentaCorrienteItem.idTipoValor}
                                                    disabled={true}
                                                    lista="TipoValor"
                                                />
                                            </div>
                                            <div className="mb-3 col-4">
                                                <label htmlFor="importeDebe" className="form-label">Debe</label>
                                                <InputNumber
                                                    name="importeDebe"
                                                    placeholder=""
                                                    className="form-control"
                                                    value={state.entity.cuentaCorrienteItem.importeDebe}
                                                    disabled={true}
                                                    precision={2}
                                                />
                                            </div>
                                            <div className="mb-3 col-4">
                                                <label htmlFor="importeHaber" className="form-label">Haber</label>
                                                <InputNumber
                                                    name="importeHaber"
                                                    placeholder=""
                                                    className="form-control"
                                                    value={state.entity.cuentaCorrienteItem.importeHaber}
                                                    disabled={true}
                                                    precision={2}
                                                />
                                            </div>
                                        </div>
                                    </Accordion>
                                </div>

                                <div className="mb-3 col-12">
                                    <Accordion title="Emisión">
                                        <div className='row form-basic'>
                                            <div className="mb-3 col-12 col-md-2">
                                                <label htmlFor="fechaOrigen" className="form-label">Origen</label>
                                                <DatePickerCustom
                                                    name="fechaOrigen"
                                                    placeholder=""
                                                    className="form-control"
                                                    value={state.entity.cuentaCorrienteItem.fechaOrigen}
                                                    disabled={true}
                                                />
                                            </div>
                                            <div className="mb-3 col-12 col-md-2">
                                                <label htmlFor="periodoEmision"
                                                       className="form-label">Periodo</label>
                                                <InputEjercicio
                                                    name="periodoEmision"
                                                    placeholder=""
                                                    className="form-control"
                                                    value={state.entity.emisionEjecucion.periodo}
                                                    disabled={true}
                                                />
                                            </div>
                                            <div className="mb-3 col-12 col-md-2">
                                                <label htmlFor="numeroEmision" className="form-label">Número</label>
                                                <InputCodigo
                                                    name="numeroEmision"
                                                    type="text"
                                                    className="form-control"
                                                    value={state.entity.emisionEjecucion.numero}
                                                    disabled={true}
                                                />
                                            </div>
                                            <div className="mb-3 col-12 col-md-2">
                                                <label htmlFor="certificadoApremio" className="form-label">N°
                                                    Juicio</label>
                                                <InputCodigo
                                                    name="certificadoApremio"
                                                    type="text"
                                                    className="form-control"
                                                    value={state.entity.certificadoApremio.numero}
                                                    disabled={true}
                                                />
                                            </div>

                                            <div className="mb-3 col-12 col-md-4">
                                                <label htmlFor="edesurCliente"
                                                       className="form-label">Cliente</label>
                                                <InputPersona
                                                    name="edesurCliente"
                                                    placeholder=""
                                                    className="form-control"
                                                    value={state.entity.edesurCliente.idPersona}
                                                    disabled={true}
                                                />
                                            </div>
                                        </div>
                                    </Accordion>
                                </div>

                                {(hasAsignacionOrigenes || hasAsignacionDestinos) &&
                                <div className="mb-3 col-12">
                                    <Accordion title="Asignación">
                                        <div className='row form-basic'>
                                            {hasAsignacionOrigenes &&
                                            <div className="mb-3 col-12">
                                                <label className="form-label label-subtitle">Créditos aplicados a esta partida</label>
                                                <TableCustom
                                                    className={'TableCustomBase'}
                                                    columns={asignacionOrigenesColumns}
                                                    data={state.entity.asignacionOrigenes}
                                                    showFilterGlobal={false}
                                                    showDownloadCSV={false}
                                                />
                                            </div>
                                            }
                                            {hasAsignacionDestinos &&
                                            <div className="mb-3 col-12">
                                                <label className="form-label label-subtitle">Deudas que canceló este crédito</label>
                                                <TableCustom
                                                    className={'TableCustomBase'}
                                                    columns={asignacionDestinosColumns}
                                                    data={state.entity.asignacionDestinos}
                                                    showFilterGlobal={false}
                                                    showDownloadCSV={false}
                                                />
                                            </div>
                                            }
                                        </div>
                                    </Accordion>
                                </div>
                                }

                                {hasRetencion &&
                                <div className="mb-3 col-12">
                                    <Accordion title="Retención">
                                        <div className='row form-basic'>
                                            {retencionRecibida &&
                                            <>
                                            <div className="mb-3 col-12 col-md-3">
                                                <label htmlFor="cuentaAgente" className="form-label">Cuenta del agente</label>
                                                <div className="wrapper">
                                                    <input
                                                        name="cuentaAgente"
                                                        type="text"
                                                        className="form-control text-truncate"
                                                        style={{ paddingRight: canViewCuentaCorriente ? '28px' : undefined }}
                                                        value={state.entity.retencion.numeroCuentaAgente}
                                                        disabled={true}
                                                    />
                                                    {canViewCuentaCorriente &&
                                                    <span
                                                        className="material-symbols-outlined icon-cruz"
                                                        style={{ right: '2px', fontSize: '18px' }}
                                                        onClick={ (event) => handleClickPartidaView(state.entity.retencion.idCuentaAgente, state.entity.retencion.numeroPartidaAgente) }
                                                        title="Ver cuenta corriente de la partida"
                                                    >open_in_new</span>
                                                    }
                                                </div>
                                            </div>
                                            <div className="mb-3 col-12 col-md-3">
                                                <label htmlFor="cuitAgente" className="form-label">CUIT</label>
                                                <input
                                                    name="cuitAgente"
                                                    type="text"
                                                    className="form-control"
                                                    value={state.entity.retencion.cuitAgente}
                                                    disabled={true}
                                                />
                                            </div>
                                            <div className="mb-3 col-12 col-md-6">
                                                <label htmlFor="nombreAgente" className="form-label">Razón social</label>
                                                <input
                                                    name="nombreAgente"
                                                    type="text"
                                                    className="form-control"
                                                    value={state.entity.retencion.nombreAgente}
                                                    disabled={true}
                                                />
                                            </div>
                                            </>
                                            }
                                            <div className="mb-3 col-12 col-md-3">
                                                <label htmlFor="fechaPresentacion" className="form-label">Fecha presentación</label>
                                                <DatePickerCustom
                                                    name="fechaPresentacion"
                                                    placeholder=""
                                                    className="form-control"
                                                    value={state.entity.retencion.fechaPresentacion}
                                                    disabled={true}
                                                />
                                            </div>
                                            <div className="mb-3 col-12 col-md-3">
                                                <label htmlFor="periodoDeclaracion" className="form-label">Período declarado</label>
                                                <input
                                                    name="periodoDeclaracion"
                                                    type="text"
                                                    className="form-control"
                                                    value={`${state.entity.retencion.anioDeclaracion}/${state.entity.retencion.mesDeclaracion}`}
                                                    disabled={true}
                                                />
                                            </div>
                                            {retencionRecibida &&
                                            <div className="mb-3 col-12 col-md-6">
                                                <label htmlFor="numeroComprobante" className="form-label">N° comprobante</label>
                                                <input
                                                    name="numeroComprobante"
                                                    type="text"
                                                    className="form-control"
                                                    value={state.entity.retencion.numeroComprobante}
                                                    disabled={true}
                                                />
                                            </div>
                                            }
                                        </div>
                                    </Accordion>
                                </div>
                                }

                                <div className="mb-3 col-12">
                                    <Accordion title="Vencimientos">
                                        <div className='row form-basic'>
                                            <div className="mb-3 col-12 col-md-4">
                                                <label htmlFor="fechaVencimiento1" className="form-label">Primer
                                                    vencimiento{state.entity.cuentaCorrienteItem.fechaVencimiento1Prorroga ? " (*)" : ""}</label>
                                                <DatePickerCustom
                                                    name="fechaVencimiento1"
                                                    placeholder=""
                                                    className="form-control"
                                                    value={state.entity.cuentaCorrienteItem.fechaVencimiento1}
                                                    disabled={true}
                                                />
                                            </div>
                                            {state.entity.cuentaCorrienteItem.fechaVencimiento1Prorroga &&
                                                <div className="mb-3 col-12 col-md-4">
                                                    <label htmlFor="fechaVencimiento1Original"
                                                           className="form-label">Primer vencimiento
                                                        original</label>
                                                    <DatePickerCustom
                                                        name="fechaVencimiento1Original"
                                                        placeholder=""
                                                        className="form-control"
                                                        value={state.entity.cuentaCorrienteItem.fechaVencimiento1Original}
                                                        disabled={true}
                                                    />
                                                </div>
                                            }
                                            {(state.entity.cuentaCorrienteItem.fechaVencimiento1Prorroga || state.entity.cuentaCorrienteItem.fechaVencimiento2Prorroga) &&
                                                <div className="col-12"></div>
                                            }
                                            <div className="mb-3 col-12 col-md-4">
                                                <label htmlFor="fechaVencimiento2" className="form-label">Segundo
                                                    vencimiento{state.entity.cuentaCorrienteItem.fechaVencimiento2Prorroga ? " (*)" : ""}</label>
                                                <DatePickerCustom
                                                    name="fechaVencimiento2"
                                                    placeholder=""
                                                    className="form-control"
                                                    value={state.entity.cuentaCorrienteItem.fechaVencimiento2}
                                                    disabled={true}
                                                />
                                            </div>
                                            {state.entity.cuentaCorrienteItem.fechaVencimiento2Prorroga &&
                                                <div className="mb-3 col-12 col-md-4">
                                                    <label htmlFor="fechaVencimiento2Original"
                                                           className="form-label">Segundo vencimiento
                                                        original</label>
                                                    <DatePickerCustom
                                                        name="fechaVencimiento2Original"
                                                        placeholder=""
                                                        className="form-control"
                                                        value={state.entity.cuentaCorrienteItem.fechaVencimiento2Original}
                                                        disabled={true}
                                                    />
                                                </div>
                                            }
                                            {(state.entity.cuentaCorrienteItem.fechaVencimiento1Prorroga || state.entity.cuentaCorrienteItem.fechaVencimiento2Prorroga) &&
                                                <div className="col-12">(*) Vencimiento(s) con prorroga</div>
                                            }
                                        </div>
                                    </Accordion>
                                </div>

                                <div className="mb-3 col-12">
                                    <Accordion title="Imputación contable">
                                        <div className='row form-basic'>
                                            <TableCustom
                                                className={'TableCustomBase'}
                                                columns={tableColumns}
                                                data={state.entity.cuotaPorcentajes}
                                                showFilterGlobal={false}
                                            />
                                        </div>
                                    </Accordion>
                                </div>

                                <div className="mb-3 col-12">
                                    <Accordion title="Actualización">
                                        <div className='row form-basic'>
                                            <div className="mb-3 col-4">
                                                <label htmlFor="fechaRegistro" className="form-label">Fecha
                                                    registro</label>
                                                <DatePickerCustom
                                                    name="fechaRegistro"
                                                    placeholder=""
                                                    className="form-control"
                                                    value={state.entity.cuentaCorrienteItem.fechaRegistro}
                                                    disabled={true}
                                                />
                                            </div>
                                            <div className="mb-3 col-8">
                                                <label htmlFor="idUsuarioRegistro" className="form-label">Usuario/a
                                                    registro</label>
                                                <InputUsuario
                                                    name="idUsuarioRegistro"
                                                    placeholder=""
                                                    className="form-control"
                                                    value={state.entity.cuentaCorrienteItem.idUsuarioRegistro}
                                                    disabled={true}
                                                />
                                            </div>
                                            <div className="mb-3 col-4">
                                                <label htmlFor="fechaProceso" className="form-label">Fecha
                                                    proceso</label>
                                                <DatePickerCustom
                                                    name="fechaProceso"
                                                    placeholder=""
                                                    className="form-control"
                                                    value={state.entity.cuentaCorrienteItem.fechaProceso}
                                                    disabled={true}
                                                />
                                            </div>
                                            <div className="mb-3 col-8">
                                                <label htmlFor="idUsuarioProceso" className="form-label">Usuario/a
                                                    proceso</label>
                                                <InputUsuario
                                                    name="idUsuarioProceso"
                                                    placeholder=""
                                                    className="form-control"
                                                    value={state.entity.cuentaCorrienteItem.idUsuarioProceso}
                                                    disabled={true}
                                                />
                                            </div>
                                        </div>
                                    </Accordion>
                                </div>

                            </div>
                )}
                footer={(
                            <button className="btn back-button" data-dismiss="modal"
                                    onClick={(event) => props.onDismiss()}>Volver
                            </button>
                )}
                footerClassName="f-align"
            />

        </>
    );
}

CuentaCorrienteItemModal.propTypes = {
    data: object.isRequired,
    onDismiss: func.isRequired
};

export default CuentaCorrienteItemModal;
